import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper";
import { OficinaVirtual} from "./Cards/OficinaVirtual";
import { Coworking} from "./Cards/Coworking";
import { OficinaPrivada } from "./Cards/OficinaPrivada";
import { Master } from "./Cards/Master";
import style from "./Planes.module.css";


export const Planes = () => {
  const planes = [
    <OficinaVirtual
      key="virtual"
      title={"Oficina Virtual"}
      text={"Ideal para personas que viven fuera de los limites de la ciudad capital y necesitan contar con un espacio dentro de la capital."}
      cost={" Q 499.00 "}
    />,
    <div key="coworking-wrapper">
      <div className={style.popular}>
        <p className={style.popuText}>MAS POPULAR</p>
        <Coworking
          title={"Coworking"}
          text={"El espacio idóneo para pequeños emprendedores con deseo de crecer al máximo su negocio. "}
          cost={" Q 1,299.00 "}
        />
      </div>
    </div>,
    <OficinaPrivada
      key="privada"
      title={"Oficina Privada"}
      text={"Disfruta de tu propio espacio privado con las amenidades necesarias para crecer tu negocio. "}
      cost={" Q 3,500.00 "}
    />,
    <Master
      key="master"
      title={"Master"}
      text={"All inclusive, todo lo que puedes llegar a necesitar para tu día a día laboral. "}
      cost={" Q 10,199.00 "}
    />
  ];

  return (
    <div>
      <div>
        <h3 className={style.title}>Nuestros Planes</h3>
      </div>
      {/* Grid para Desktop */}
      <div className={`${style.container} ${style.desktopContainer}`} id="planes">
        <OficinaVirtual
          title={"Oficina Virtual"}
          text={"Ideal para personas que viven fuera de los limites de la ciudad capital y necesitan contar con un espacio dentro de la capital."}
          cost={" Q 499.00 "}
        />
        <div>
          <div className={style.popular}>
            <p className={style.popuText}>MAS POPULAR</p>
            <Coworking
              title={"Coworking"}
              text={"El espacio idóneo para pequeños emprendedores con deseo de crecer al máximo su negocio. "}
              cost={" Q 1,299.00 "}
            />
          </div>
        </div>
        <OficinaPrivada
          title={"Oficina Privada"}
          text={"Disfruta de tu propio espacio privado con las amenidades necesarias para crecer tu negocio. "}
          cost={" Q 3,500.00 "}
        />
        <Master
          title={"Master"}
          text={"All inclusive, todo lo que puedes llegar a necesitar para tu día a día laboral. "}
          cost={" Q 10,199.00 "}
        />
      </div>

      {/* Carousel para Mobile */}
      <div className={style.mobileContainer}>
        <Swiper
          modules={[Navigation, Pagination]}
          navigation
          pagination={{ clickable: true }}
          spaceBetween={30}
          slidesPerView={1}
          centeredSlides={true}
        >
          <SwiperSlide>
            <div className={style.slideWrapper}>
              <OficinaVirtual
                title={"Oficina Virtual"}
                text={"Ideal para personas que viven fuera de los limites de la ciudad capital y necesitan contar con un espacio dentro de la capital."}
                cost={" Q 499.00 "}
              />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={style.slideWrapper}>
              <div className={style.popular}>
                <p className={style.popuText}>MAS POPULAR</p>
                <Coworking
                  title={"Coworking"}
                  text={"El espacio idóneo para pequeños emprendedores con deseo de crecer al máximo su negocio. "}
                  cost={" Q 1,299.00 "}
                />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={style.slideWrapper}>
              <OficinaPrivada
                title={"Oficina Privada"}
                text={"Disfruta de tu propio espacio privado con las amenidades necesarias para crecer tu negocio. "}
                cost={" Q 3,500.00 "}
              />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={style.slideWrapper}>
              <Master
                title={"Master"}
                text={"All inclusive, todo lo que puedes llegar a necesitar para tu día a día laboral. "}
                cost={" Q 10,199.00 "}
              />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};
